import { Link } from "react-router-dom";

type SectionTitleProps = {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
};

export default function SectionTitle({
  title,
  subtitle,
  moreTo,
  moreLabel = "更多",
  icon = "ri-fire-line",
}: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-1.5 h-6 rounded-full bg-primary-500" />
        <div className="min-w-0">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 flex items-center gap-2">
            <i className={`${icon} text-primary-500`} />
            {title}
          </h2>
          {subtitle && <p className="text-xs text-foreground-500 mt-1 pl-6 hidden sm:block">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}